module.exports = __webpack_public_path__ + "static/media/Layer.9988288c.svg";